import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { MaterialsComponent } from './materials.component';
import { AuthGuardService } from '../shared/services/auth-guard.service';
import { DenyStaffService } from '../shared/services/deny-staff.service';
import { DenyNonStaffService } from '../shared/services/deny-non-staff.service';
import { MaterialsService } from './materials.service';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    SharedModule,
    FormsModule,
    RouterModule.forChild([
      { path: 'materials', component: MaterialsComponent, canActivate:[AuthGuardService, DenyNonStaffService, DenyStaffService] }
    ])
  ],
  providers: [
    MaterialsService
  ],
  declarations: [MaterialsComponent]
})
export class MaterialsModule { }



// WEBPACK FOOTER //
// ./src/app/materials/materials.module.ts